export enum VisualizerColorTheme {
	LIGHT = 'LIGHT',
	DARK = 'DARK',
	DEFAULT = 'DEFAULT',
}
